import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FaCode, FaPlay } from 'react-icons/fa';
import Fade from 'react-reveal/Fade';

import placeholder from '../../../assets/png/placeholder.png';
import './SingleProject.css';

const useStyles = makeStyles(() => ({
    iconBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        borderRadius: 50,
        border: ({ theme }) => `2px solid ${theme.tertiary}`,
        color: ({ theme }) => theme.tertiary,
        transition: 'all 0.2s',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.secondary,
            color: ({ theme }) => theme.primary,
            transform: 'scale(1.1)',
            border: ({ theme }) => `2px solid ${theme.secondary}`,
        },
    },
    icon: {
        fontSize: '1.1rem',
        transition: 'all 0.2s',
    },
}));

function SingleProject({ id, name, desc, tags, code, demo, image, theme }) {
    const classes = useStyles({ theme });

    const formatIdentifier = (str) => str.replace(/\s+/g, '-').toLowerCase();
    
    const projectSlug = formatIdentifier(name);

    return (
        <Fade bottom>
            <div
                key={id}
                className='singleProject'
                style={{ backgroundColor: theme.quaternary }}
            >
                <div className='projectContent'>
                    <h2 id={projectSlug} style={{ color: theme.tertiary }}>
                        {name}
                    </h2>
                    
                    <img src={image || placeholder} alt={name} />
                    
                    <div className='project--showcaseBtn'>
                        <a
                            href={demo}
                            target='_blank'
                            rel='noreferrer'
                            className={classes.iconBtn}
                            aria-labelledby={`${projectSlug} ${projectSlug}-demo`}
                        >
                            <FaPlay
                                id={`${projectSlug}-demo`}
                                className={classes.icon}
                                aria-label='Demo'
                            />
                        </a>
                        
                        <a
                            href={code}
                            target='_blank'
                            rel='noreferrer'
                            className={classes.iconBtn}
                            aria-labelledby={`${projectSlug} ${projectSlug}-code`}
                        >
                            <FaCode
                                id={`${projectSlug}-code`}
                                className={classes.icon}
                                aria-label='Code'
                            />
                        </a>
                    </div>
                </div>
                
                <p
                    className='project--desc'
                    style={{
                        background: theme.secondary,
                        color: theme.tertiary,
                    }}
                >
                    {desc}
                </p>
                
                <div
                    className='project--lang'
                    style={{
                        background: theme.secondary,
                        color: theme.tertiary,
                    }}
                >
                    {tags.map((tag, tagId) => (
                        <span key={tagId}>{tag}</span>
                    ))}
                </div>
            </div>
        </Fade>
    );
}

export default SingleProject;